import React from "react";

export default function Report() {
  return (
    <React.Fragment>
      <div className="container-main">
        <div>Report</div>
      </div>
    </React.Fragment>
  );
}
